export default "> [!INFO]\r\n> \r\n> tags:  #🕸️/⬜ #🗺️  \r\n> References:   \r\n> Links: \r\n\r\nA place for all my saved recipes";